<template>
  <div>
    <div class="corzo-page-title-wrap corzo-style-custom corzo-left-align">
      <div class="corzo-header-transparent-substitute"></div>
      <div class="corzo-page-title-overlay"></div>
      <div class="corzo-page-title-container corzo-container">
        <div class="corzo-page-title-content corzo-item-pdlr">
          <div class="corzo-page-caption">News</div>
          <h1 class="corzo-page-title">{{ title }}</h1>
          <div class="corzo-page-caption-divider"></div>
        </div>
      </div>
    </div>

    <div class="gdlr-core-pbf-wrapper" style="padding: 0px 0px 0px 0px;">
      <div class="gdlr-core-pbf-background-wrap" style="background-color: #f5f5f5;"></div>
      <div class="gdlr-core-pbf-background-wrap" style="top: 350px;">
        <div class="gdlr-core-pbf-background gdlr-core-parallax gdlr-core-js" style="background-image: url(upload/hp2-about-bg.png); background-repeat: no-repeat; background-position: top center;" data-parallax-speed="0"></div>
      </div>
      <div class="gdlr-core-pbf-wrapper-content gdlr-core-js">
        <div class="gdlr-core-pbf-wrapper-container clearfix gdlr-core-container">
          <iframe id="news" style="width: 100%;" :style="iframeStyle" :src="url"></iframe>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'News',
  data () {
    return {
      media_id: '',
      url: '',
      iframeStyle: {
        height: '3000px'
      },
      title: ''
    }
  },
  methods: {
    init () {
      setInterval(() => {
        var el = document.getElementById('news')
        this.iframeStyle.height = el.contentWindow.document.body.offsetHeight + 'px'
      }, 1000)
      if (typeof this.$route.params.media_id !== 'undefined') {
        this.media_id = this.$route.params.media_id
        this.url = 'https://www.huidetrust.com/service/user.do/news/media?media_id=' + this.media_id
      }

      if (typeof this.$route.params.type !== 'undefined') {
        this.type = this.$route.params.type
        if (this.type === '1') {
          this.title = '匯德新闻'
          this.getList()
        } else if (this.type === '2') {
          this.title = '媒体报道'
        }
      }
    }
  },
  mounted () {
    this.init()
    console.log(this.$route.params)
  },
  watch: {
    $route: 'init'
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/News.vue